import './Print.css';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getDataObjArray, loadHoursCalendar, loadMinutesCalendar } from '../Sidebar/SideBarUtils';

function PrintBar({ timeIni, timeFim, onComboChange }) { 
    const { t } = useTranslation();
    const [defHrIni, setdefHrIni] = useState<string>('');
    const [defHrFim, setdefHrFim] = useState<string>('');
    const [defMinIni, setdefMinIni] = useState<string>('');
    const [defMinFim, setdefMinFim] = useState<string>(''); 

    let combHr =  loadHoursCalendar();
    let combMin = loadMinutesCalendar();

    useEffect(() => {
        setDefValues();
    }, [timeIni, timeFim]);

    function setDefValues() {
        setdefHrIni(timeIni.split(':')[0]);
        setdefMinIni(timeIni.split(':')[1]);
        setdefHrFim(timeFim.split(':')[0]);
        setdefMinFim(timeFim.split(':')[1]);
    }
    const trocaHrIni = event => {
        setdefHrIni(event.currentTarget.value);
        onComboChange('HrIni', event.currentTarget.value);
    }
    const trocaHrFim = event => {
        setdefHrFim(event.currentTarget.value);
        onComboChange('HrFim', event.currentTarget.value);
    }
    const trocaMinIni = event => {
        setdefMinIni(event.currentTarget.value);
        onComboChange('MinIni', event.currentTarget.value);
    }
    const trocaMinFim = event => {
        setdefMinFim(event.currentTarget.value);
        onComboChange('MinFim', event.currentTarget.value);
    } 
    return (

        <div data-testid="divPrintBar">
            <ul className='printbar-header' >
                <label style={{
                    fontFamily: 'Geist, sans-serif',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    marginBottom: '12px',
                    display: 'block'
                }}>{t("rows.startingTime")}</label>
            </ul>
            <div className='printbar' style={{ display: 'flex', gap: '12px', padding: '0 20px', marginBottom: '20px' }}>
                <ul className='printbar-div' style={{ flex: 1, listStyle: 'none', padding: 0 }}>
                    <label style={{
                        fontFamily: 'Geist, sans-serif',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#1a1a1a',
                        marginBottom: '6px',
                        display: 'block'
                    }}>{t("rows.hour")}</label>
                    <select 
                        className='indice-combo' 
                        name="comboIniHr" 
                        value={defHrIni} 
                        onChange={trocaHrIni}
                        style={{
                            width: '100%',
                            height: '44px',
                            padding: '10px 14px',
                            border: '2px solid #e0e0e6',
                            borderRadius: '8px',
                            fontFamily: 'Geist, sans-serif',
                            fontSize: '15px',
                            color: '#1a1a1a',
                            backgroundColor: '#ffffff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            outline: 'none'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.borderColor = '#b8b8c2';
                            e.currentTarget.style.backgroundColor = '#fafafa';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.borderColor = '#e0e0e6';
                            e.currentTarget.style.backgroundColor = '#ffffff';
                        }}
                        onFocus={(e) => {
                            e.currentTarget.style.borderColor = '#0032ff';
                            e.currentTarget.style.backgroundColor = '#ffffff';
                            e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 50, 255, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.currentTarget.style.borderColor = '#e0e0e6';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >                        
                    {getDataObjArray(combHr).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)} 
                    </select>
                </ul>
                <ul className='printbar-div' style={{ flex: 1, listStyle: 'none', padding: 0 }}>
                    <label style={{
                        fontFamily: 'Geist, sans-serif',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#1a1a1a',
                        marginBottom: '6px',
                        display: 'block'
                    }}>{t("rows.minute")}</label>
                    <select 
                        className='indice-combo' 
                        name="comboIniMin" 
                        value={defMinIni} 
                        onChange={trocaMinIni}
                        style={{
                            width: '100%',
                            height: '44px',
                            padding: '10px 14px',
                            border: '2px solid #e0e0e6',
                            borderRadius: '8px',
                            fontFamily: 'Geist, sans-serif',
                            fontSize: '15px',
                            color: '#1a1a1a',
                            backgroundColor: '#ffffff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            outline: 'none'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.borderColor = '#b8b8c2';
                            e.currentTarget.style.backgroundColor = '#fafafa';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.borderColor = '#e0e0e6';
                            e.currentTarget.style.backgroundColor = '#ffffff';
                        }}
                        onFocus={(e) => {
                            e.currentTarget.style.borderColor = '#0032ff';
                            e.currentTarget.style.backgroundColor = '#ffffff';
                            e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 50, 255, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.currentTarget.style.borderColor = '#e0e0e6';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                    {getDataObjArray(combMin).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)}                         
                    </select>
                </ul>
            </div>
            <ul className='printbar-header' >
                <label style={{
                    fontFamily: 'Geist, sans-serif',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    marginBottom: '12px',
                    display: 'block'
                }}>{t("rows.endingTime")}</label>
            </ul>
            <div className='printbar' style={{ display: 'flex', gap: '12px', padding: '0 20px' }}>
                <ul className='printbar-div' style={{ flex: 1, listStyle: 'none', padding: 0 }}>
                    <label style={{
                        fontFamily: 'Geist, sans-serif',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#1a1a1a',
                        marginBottom: '6px',
                        display: 'block'
                    }}>{t("rows.hour")}</label>
                    <select 
                        className='indice-combo' 
                        name="comboFimHr" 
                        value={defHrFim} 
                        onChange={trocaHrFim}
                        style={{
                            width: '100%',
                            height: '44px',
                            padding: '10px 14px',
                            border: '2px solid #e0e0e6',
                            borderRadius: '8px',
                            fontFamily: 'Geist, sans-serif',
                            fontSize: '15px',
                            color: '#1a1a1a',
                            backgroundColor: '#ffffff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            outline: 'none'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.borderColor = '#b8b8c2';
                            e.currentTarget.style.backgroundColor = '#fafafa';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.borderColor = '#e0e0e6';
                            e.currentTarget.style.backgroundColor = '#ffffff';
                        }}
                        onFocus={(e) => {
                            e.currentTarget.style.borderColor = '#0032ff';
                            e.currentTarget.style.backgroundColor = '#ffffff';
                            e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 50, 255, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.currentTarget.style.borderColor = '#e0e0e6';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                    {getDataObjArray(combHr).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)} 
                    </select>
                </ul>
                <ul className='printbar-div' style={{ flex: 1, listStyle: 'none', padding: 0 }}>
                    <label style={{
                        fontFamily: 'Geist, sans-serif',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#1a1a1a',
                        marginBottom: '6px',
                        display: 'block'
                    }}>{t("rows.minute")}</label>
                    <select 
                        className='indice-combo' 
                        name="comboFimMin" 
                        value={defMinFim} 
                        onChange={trocaMinFim}
                        style={{
                            width: '100%',
                            height: '44px',
                            padding: '10px 14px',
                            border: '2px solid #e0e0e6',
                            borderRadius: '8px',
                            fontFamily: 'Geist, sans-serif',
                            fontSize: '15px',
                            color: '#1a1a1a',
                            backgroundColor: '#ffffff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            outline: 'none'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.borderColor = '#b8b8c2';
                            e.currentTarget.style.backgroundColor = '#fafafa';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.borderColor = '#e0e0e6';
                            e.currentTarget.style.backgroundColor = '#ffffff';
                        }}
                        onFocus={(e) => {
                            e.currentTarget.style.borderColor = '#0032ff';
                            e.currentTarget.style.backgroundColor = '#ffffff';
                            e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 50, 255, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.currentTarget.style.borderColor = '#e0e0e6';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                    {getDataObjArray(combMin).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)}                     
                    </select>
                </ul>
            </div>
        </div >
    );
}

export default PrintBar;